import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { ServiceSpecificationService } from '../../../core/services/service/service-specification/service-specification.service'
import { MatSelectModule } from '@angular/material/select'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { PaymentMethodsService } from '../../../core/services/payment/payment-methods/payment-methods.service'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { VehicleModelService } from '../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { PassagersComponent } from '../../passengers/passengers.component'
import { ItineraryComponent } from '../../itineraries/itinerary-service-order/itinerary.component'
import { ContractClientService } from '../../../core/services/contract/contract-client/contract-client.service'
import { ContractItemService } from '../../../core/services/contract/contract-item/contract-item.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { ProposalStatusService } from '../../../core/services/proposal/proposal-status/proposal-status.service'
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { ServiceOrderEdit } from './service-order-edit/service-order-edit.component'
import { MatProgressSpinner } from "@angular/material/progress-spinner";




@Component({
  selector: 'service-order',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatButtonModule,
    MatSelectModule,
    PassagersComponent,
    MatCard,
    MatStepperModule,
    MatIconModule,
    MatCardHeader,
    MatCardTitle,
    MatStepperModule,
    ItineraryComponent,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ServiceOrderEdit,
    MatProgressSpinner
  ],
  templateUrl: './service-order.component.html',
  styleUrl: './service-order.component.scss',
  providers: [
    ServiceOrderService,
    PaymentMethodsService
  ],
  standalone: true,
})
export class ServiceOrder implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private paymentMethodsService: PaymentMethodsService,
    private commissionDividerService: CommissionDividerService,
    private serviceOrderService: ServiceOrderService,
    private serviceSpecificationService: ServiceSpecificationService,
    private contractItemService: ContractItemService,
    private contractClienteService: ContractClientService,
    private ordemService: ServiceOrderService,
    private serviceTypeService: ServiceTypeService,
    private driverTypeService: DriverTypeService,
    private snackbar: SnackbarCustomService,
    private vehicleModelService: VehicleModelService,
    private vehicleTpeService: VehicleTypeService,
    private dialogRef: MatDialogRef<ServiceOrder>,
    private employeeService: EmployeeService,
    private proposalStatusService: ProposalStatusService,
    @Inject(MAT_DIALOG_DATA) public data: any,

  ) { }

  @Output() responseCreate = new EventEmitter()
  @Output() response = new EventEmitter()
  @Output() itemPropostaId = new EventEmitter();
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined
  @ViewChild(ServiceOrderEdit) serviceOrderEdit!: ServiceOrderEdit;
  @Input() idItemContract = -1
  @Input() idContractClient = -1


  edit: any = false
  osInformation = false
  passengersValid = false;
  itineraryValid = false;
  scheduleValid = false;
  formLegalEntity: FormGroup = new FormGroup({})
  page = 1
  rows = 10
  numberRows = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  form: FormGroup = new FormGroup({})
  loading = false
  item: any = { user: false, data: [] }
  idClient = -1
  maxDate!: Date
  idItemProposta: any = -1



  ListProposalStatus: any[] = []
  ListPaymentMethods: any[] = []
  itemsList: any[] = []
  ListCommission: any[] = [
    { value: 0, description: 'Tgmob', disabled: false },
    { value: 1, description: 'Cliente', disabled: true },
    { value: 2, description: 'Personalizado', disabled: false },
  ]



  listType = [
    { id: 'ativo', nome: 'Ativo' },
    { id: 'inativo', nome: 'Inativo' },
    { id: 'pendente', nome: 'Pendente' }
  ];




  nextEvent: any = false
  finalized: any = false
  ListItemsProposal: any[] = []
  vehicleTypeList: any[] = []
  listTypeDriver: any[] = []
  clientSelected: any = {}
  subClientSelected: any = {}
  consultantClientSelected: any = {}
  employeeConsultantSelected: any = {}
  editIndex: number | null = null;
  editAgendaItem: any = null;
  dataOs: any



  ngOnInit(): void {
    this.listTypeVehicle()
    this.createForm()
    this.listTypeService()
    this.getDriverType()
    this.getListItems()




    if (this.data.item.statusId === 4 || this.data.item.statusId === 5) this.finalized = true

    this.edit = this.data.edit

    if (this.data && this.data.idOs) {
      this.formLegalEntity.patchValue({ os: this.data.idOs });
    }

    if (this.data && this.data.dataInicio) {
      const [dia, mes, ano] = this.data.dataInicio.split('/');
      const dataInicioDate = new Date(+ano, +mes - 1, +dia);
      this.formLegalEntity.patchValue({ dataInicio: dataInicioDate });
    }
    if (this.data && this.data.dataFim) {
      const [dia, mes, ano] = this.data.dataFim.split('/');
      const dataFimDate = new Date(+ano, +mes - 1, +dia);
      this.formLegalEntity.patchValue({ dataFim: dataFimDate });
    }

    if (this.data && this.data.contratoItemId) {
      this.idItemContract = this.data.contratoItemId;
    }
    this.getItemContractByContract()


  }

  // onResponse(valor: boolean, stepper: MatStepperModu) {
  //   if (valor) {
  //     stepper.next(); // avança automaticamente
  //   }
  // }

  onPassengersValid(valid: boolean) {
    this.passengersValid = valid;
  }

  onScheduleValid(valid: boolean) {
    this.scheduleValid = valid;
  }

  formatDate(date: string): string {
    const dateObject = new Date(date);
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    const day = (dateObject.getDay() + 1).toString().padStart(2, '0');
    return `${day}/${month}/${dateObject.getFullYear()}`;
  }

  submitForm() {
    this.loading = true

    if (this.serviceOrderEdit.formLegalEntity.valid) {
      const formData = this.serviceOrderEdit.formLegalEntity.value;
      const data = {
        id: this.data.item.codigoOs,
        statusId: this.data.item.statusId,
        dataInicio: this.formatDate(formData.dateInitial),
        dataFinal: this.formatDate(formData.dateFinal),
        horaInicial: this.formatHours(formData.timeStart),
        horaFinal: this.formatHours(formData.timeFinal),
        observacao: formData.observation,
        valorTarifario: formData.valueTariff,
        valorProposta: formData.valueProposal,
        valorCompra: formData.valueBuy
      };

      this.serviceOrderService.editServiceOrder(data).subscribe({
        next: (res: any) => {
          this.snackbar.success(res.message);
          this.loading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.snackbar.error(err.message);
          this.loading = false;
        },
      });
    } else {
      this.loading = false
      this.snackbar.warning('Preencha todos os campos obrigatórios!');
    }
  }

  formatHours(hours: any) {
    // const date = new Date();
    // date.setHours(hours);

    return `${hours}:00`;
  }


  handleValid(value: boolean) {

    this.itineraryValid = value;
  }

  serviceValid(value: boolean) {
    this.osInformation = value;
  }




  getDriverType() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: any) => {
        const list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listTypeDriver = list
      },
      error: (err: any) => { },
      complete: () => { },
    })
  }




  listTypeVehicle() {
    this.vehicleTpeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.vehicleTypeList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  listTypeService() {
    // this.serviceTypeService.listServiceType().subscribe({
    //   next: (response: ResponseRequestModel) => {
    //     this.listType = response.data.map((item: any) => ({
    //       id: item.id,
    //       nome: item.descricao
    //     }));
    //   },
    //   error: (err: ResponseRequestModel) => {
    //     console.error(err)
    //   },
    //   complete: () => { },
    // })
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.serviceSpecificationService
      .createServiceSpecification(model)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
  }



  getListItems() {
    this.loading = true
    this.serviceOrderService
      .listPagedServiceOrderOrdenation(this.page, this.rows, this.data.idOs)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }


  getItemContractByContract() {
    // this.ordemService.getServiceOrderbyId(this.)
    this.loading = true
    this.contractItemService
      .getContractItembyId(this.idItemContract)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          if (response && response.data && response.data.contratoId) {
            this.idContractClient = response.data.contratoId;
            this.preencherFormularioComItemContrato(response.data)
            this.getContractCliente()
          }
          this.itemPropostaId.emit(response.data.itemPropostaId)
          this.idItemProposta = response.data.itemPropostaId;

          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }


  preencherFormularioComContrato(data: any) {
    this.formLegalEntity.patchValue({
      nomeEvento: data.nomeEvento ?? '',
      status: data.descricaoStatusOs ?? '',
      cliente: data.nomeCliente ?? '',
      subClient: data.nomeSubCliente ?? '',
      consultorCliente: data.nomeConsultor ?? '',
      consultorComercial: data.consultorComercial ?? '',
      qtdPassageiros: data.quantidadePassageiros ?? '',

      // ...outros campos que desejar
    });

  }



  preencherFormularioComItemContrato(data: any) {
    this.formLegalEntity.patchValue({
      servico: data.tipoServicoDescricao ?? '',
      tipoServico: data.serfvicoDescricao ?? '',
      typeDriver: data.tipoMotoristaId ?? '',
      vehicle: data.tipoVeiculoId ?? '',
      // ...outros campos que desejar
    });

  }


  getContractCliente() {
    this.loading = true
    this.ordemService
      .getServiceOrderbyId(this.data.idOs)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          if (response && response.data) {
            this.preencherFormularioComContrato(response.data);
          }

          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }



  treatResponse(response: any) {
    const list = []
    if (response.data) {


      for (const itens in response.data) {
        list.push(itens)
      }

    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }






  close() {
    this.dialogRef.close()

  }

  createModel() {
    return {
      descricao: this.form.controls['description'].value,
      tipoServicoId: this.form.controls['typeService'].value,
      exigeVeiculo: this.form.get('vehicle')!.value ? 'S' : 'N',
    }
  }

  createForm(): void {
    this.formLegalEntity = this.formBuilder.group({
      codigoTG: [''],
      os: [''],
      status: [''],
      cliente: [''],
      subCliente: [''],
      consultorCliente: [''],
      consultorComercial: [''],
      nomeEvento: [''],
      dataInicio: [''],
      dataFim: [''],
      tipoServico: [''],
      servico: [''],
      fornecedor: [''],
      typeService: ['', [Validators.required]],
      vehicle: [''],
      tipoMotorista: [''],
      motorista: [''],
      qtdPassageiros: [''],
      tipoVeiculo: [''],
      veiculo: [''],
      typeDriver: ['', [Validators.required]],
    })
  }









  clearItem(items: string[]) {
    if (items.includes('client')) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
    }
    if (items.includes('subClient')) {
      this.subClientSelected = {}
      this.form.get('subClient')!.setValue('')
    }
    if (items.includes('consultant')) {
      this.consultantClientSelected = {}
      this.form.get('consultant')!.setValue('')
    }
    if (items.includes('employeeConsultant')) {
      this.employeeConsultantSelected = {}
      this.form.get('employeeConsultant')!.setValue('')
    }
    if (items.includes('paymentMethod')) {
      this.ListPaymentMethods = []
      this.form.get('paymentMethod')!.setValue('')
    }
  }

  // loadProposalStatusAndFillForm() {
  //   // Supondo que você tenha um service para buscar os status
  //   this.proposalStatusService
  //     .listProposalStatus()
  //     .subscribe({
  //       next: (response: ResponseRequestModel) => {
  //         this.ListProposalStatus = response.data;

  //         if (this.data) {
  //           this.formLegalEntity.patchValue({
  //             // Dados principais
  //             eventName: this.data.nomeEvento ?? '',
  //             client: this.data.nomeCliente ?? '',
  //             subClient: this.data.nomeSubCliente ?? '',
  //             consultantClient: this.data.nomeConsultor ?? '',
  //             statusPropostaId: this.data.statusId ?? '',
  //             numPassengers: this.data.quantidadePassageiros ?? '',
  //             // Dados de serviço
  //             tipoServico: this.data.tipoServicoDescricao ?? '',
  //             servico: this.data.serfvicoDescricao ?? '',
  //             tipoMotorista: this.data.tipoMotoristaDescricao ?? '',
  //             tipoVeiculo: this.data.tipoVeiculoDescricao ?? '',
  //             // IDs (se quiser usar para selects)
  //             clienteId: this.data.clienteId ?? '',
  //             subClienteId: this.data.subClienteId ?? '',
  //             consultorId: this.data.consultorId ?? '',
  //             consultorComercialId: this.data.consultorComercialId ?? '',
  //             tipoServicoId: this.data.tipoServicoId ?? '',
  //             servicoId: this.data.servicoId ?? '',
  //             tipoMotoristaId: this.data.tipoMotoristaId ?? '',
  //             tipoVeiculoId: this.data.tipoVeiculoId ?? '',
  //             quantidadeVeiculos: this.data.quantidadeVeiculos ?? '',
  //           });

  //           // Desabilite campos conforme necessário
  //           this.formLegalEntity.get('statusPropostaId')?.disable();
  //           this.formLegalEntity.get('client')?.disable();
  //           this.formLegalEntity.get('subClient')?.disable();
  //           this.formLegalEntity.get('consultantClient')?.disable();
  //         }
  //       },
  //       error: (err: ResponseRequestModel) => {
  //         console.error(err)
  //       }
  //     })
  // }

}
